import { Environment } from './environments.types';

export const environment: Environment = {
  // ssoUrl: 'https://sso-dev-frontend.secureid-digital.com.ng',
  // appDetails: {
  //   ClientId: 'Breeze.Dev',
  //   ClientSecret: '0vJ/+EqD4ATWQ6kqUc/5MLOKw/RtpNTRtWEtUCLCgBPwNIm/5fg34g/puuo8K+E3',
  //   GrantType: 'client_credentials',
  // },
  // baseAPI: 'https://bucca-v2-api.bucca.com.ng/api',
  baseAPI: 'https://bucca-v1-api-dev.bucca.com.ng/api',
  // baseAPI: 'https://bucca-v1-api-staging.bucca.com.ng/api',
  ssoBaseAPI: 'https://sso-idserver-dev.secureid-digital.com.ng/api',
  engageKey: 'pk_70302f63b618b3d9155e49e55b4e9cc0',
  adminAppUrl: 'https://bucca-v2-admin-frontend.bucca.com.ng/',
  vendorAppUrl: 'https://bucca-v2-vendor-dev.bucca.com.ng/',
  staffAppUrl: 'https://bucca-v2-staff-dev.bucca.com.ng/',
  production: true,
};
